// Central brand / NAP / SEO config. SITE_URL is env-configurable so the preview
// works while canonicals/sitemap/schema point at the production domain.
export const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://caraloom.com').replace(/\/$/, '');
export const BRAND = 'CaraLoom';
export const TAGLINE = 'Connecting Families, Facilities, and Clinicians Through Intelligent Matching.';
export const EMAIL = 'care@caraloom.com';

export const NAP = {
  name: 'CaraLoom',
  legalName: 'CaraLoom, Inc.',
  // Business address — Chantilly, VA. Used by:
  //   • MedicalOrganization PostalAddress JSON-LD (lib/seoSchemas.js)
  //   • Footer + Contact + /about pages
  //   • Google Business Profile + Bing Places verification (NAP consistency)
  // Keep this object as the SINGLE SOURCE OF TRUTH — never hardcode the
  // address anywhere else in the codebase.
  addressLocality: 'Chantilly',
  addressRegion: 'VA',
  postalCode: '20151',
  addressCountry: 'US',
};

export const BUSINESS_HOURS = [
  { days: 'Monday – Friday', hours: '8:00 AM – 8:00 PM ET' },
  { days: 'Saturday', hours: '9:00 AM – 5:00 PM ET' },
  { days: 'Sunday', hours: 'On-call support' },
];

// Reusable canonical/OG image — the branded 1200x630 share card with the
// CaraLoom badge + bold wordmark + tagline. Used as the default for every
// page's <meta property="og:image"> + Twitter card image via Seo.jsx, and
// as the MedicalOrganization.image in JSON-LD via seoSchemas.js.
export const DEFAULT_OG_IMAGE = `${SITE_URL}/brand/og-knot-1200x630.png`;

export const absoluteUrl = (path = '/') => `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
